import { Field } from "formik";
import React, { useState, useEffect, useContext } from "react";
import * as yup from "yup";
import CrudMain from "../../components/crud/CrudMain";
import FormikForm from "../../components/crud/FormikForm";
import { Accordion, Button, Card, Modal } from "react-bootstrap";
import Filters from "../../components/list/Filters";
import TextInput from "../../components/form-fields/TextInput";
import TextArea from "../../components/form-fields/TextArea";
import ListComponent from "../../components/list/ListComponent";
import Main from "../../components/main/Main";
import { useTranslation } from 'react-i18next';     
import { formatShortDate, formatTrueFalse } from "../../utils";            /* Added Line */              /* Added Line */
import ReactDatePicker from "../../components/form-fields/ReactDatePicker";
import Checkbox from "../../components/form-fields/Checkbox";
import request from "../../services/request";
import { ThemeContext } from "../../../context/ThemeContext";
import ConfirmModal from "../../components/modals/confirm-modal";

export default function AnnoucmentList() {
  const [showModal, setShowModal] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [refreshList, setRefreshList] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [initialValues, setInitialValues] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [t, i18n] = useTranslation();         /* Added Line */
  const [activeIndicatorInLeftPosition, setActiveIndicatorInLeftPosition] =
    useState("filter");
  const [filters, setFilters] = useState([]);
  const { refreshNotificationHandle, changeSpinnerStatus } = useContext(ThemeContext);
  
  const validationSchema = yup.object({
  });

  const arrangeBeforePersist = (values) => {
    let payload = {
      id: values.id,
      baslik: values.baslik,
      icerik: values.icerik,
      aktif: values.aktif,
      tarih: values.tarih,
    };
    return payload;
  };

  const adaptDataForUpdate = (data) => {
    let adaptedData = {
      id: data.id,
      baslik: data.baslik,
      icerik: data.icerik,
      aktif: data.aktif,
      tarih: new Date(data.tarih),
    };
    setInitialValues(adaptedData);
  };

  const onUpdateButtonClicked = (selectedRow) => {
    setShowModal(true);
    setIsUpdating(true);
    setSelectedRow(selectedRow);
  };

  const onDeleteButtonClicked = (selectedRow) => {
    setShowConfirmModal(true);
    setSelectedRow(selectedRow);
  };

  const deleteAnnouncement = (selectedRow) => {
    request({
      url: "duyurular/delete",
      method: "POST",
      data: {
        body: {
            id: selectedRow.id
        },
      },
    }).then((response) => {
      if (response.responseStatus === "SUCCESS") {
        setShowConfirmModal(false);
        setRefreshList(!refreshList);
      }})
  };

  const onAddButtonClicked = () => {
    setShowModal(true);
    setIsUpdating(false);
    setInitialValues({});
  };

  useEffect(() => {
    refreshNotificationHandle(true);
    changeSpinnerStatus(false);
  }, [refreshList])
  
  const linkFollow = (cell, row, rowIndex, formatExtraData) => {
    return (
      <>
      <Button className="btn-xs mr-2"
        onClick={() => {
          onUpdateButtonClicked(row);
        }}
      >
        <i className="fa fa-search color-white"></i>
      </Button>
      <Button className="btn-xs mr-2"
        onClick={() => {
          onDeleteButtonClicked(row);
        }}
      >
        <i className="fa fa-trash color-white"></i>
      </Button>
      </>
    );
  };


  return (
    <Main>
      <div className={"row"}>
        <div className="col-md-12">
          <Accordion
            className="accordion accordion-rounded-stylish accordion-bordered"
            defaultActiveKey="filter"
          >
            <div className="accordion__item" key={"filter"}>
              <Accordion.Toggle
                as={Card.Text}
                eventKey={"filter"}
                className={`accordion__header ${
                  activeIndicatorInLeftPosition === "filter" ? "" : "collapsed"
                } accordion__header--primary`}
                onClick={() =>
                  setActiveIndicatorInLeftPosition(
                    activeIndicatorInLeftPosition === "filter" ? "" : "filter"
                  )
                }
              >
                <span className="accordion__header--icon"></span>
                <span className="accordion__header--text">
                  {t("sozlesmeler.filtreleme")}
                </span>
                <span className="accordion__header--indicator"></span>
              </Accordion.Toggle>
              <Accordion.Collapse
                eventKey={"filter"}
                className="accordion__body"
              >
                <div className="accordion__body--text">
                  <Filters
                    setRefreshList={setRefreshList}
                    refreshList={refreshList}
                    setFilters={setFilters}
                  >
                    <Field
                      name="id"
                      label={t("Duyuru No")}
                      colNumber="2"
                      oper="EQ"
                      component={TextInput}
                    />
                    <Field
                      name="baslik"
                      label={t("newAnnouncements.baslik")}
                      colNumber="2"
                      oper="CONTAINS_CASE_AND_ACCENT_INSENSITIVE"
                      component={TextInput}
                    />
                    <Field
                      name="icerik"
                      label={t("newAnnouncements.icerik")}
                      colNumber="2"
                      oper="CONTAINS_CASE_AND_ACCENT_INSENSITIVE"
                      component={TextInput}
                    />
                    <Field
                      name="tarih"
                      label={t("newAnnouncements.bitisTarihi")}
                      colNumber="2"
                      oper="LESS_EQ"
                      component={ReactDatePicker}
                    />
                  </Filters>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </div>
      <div className="row">
      <div className="col-xl-12 col-xxl-12">
        <CrudMain
          onAddButtonClicked={onAddButtonClicked}
          showModal={showModal}
          setShowModal={setShowModal}
          title={t("newAnnouncements.duyuru")}
        >
          <FormikForm
            isUpdating={isUpdating}
            entityId={selectedRow && selectedRow.id}
            entityFetchId="id"
            endPointUrl="duyurular/create"
            fetchPointUrl="duyurular/find"
            editPointUrl="duyurular/update"
            arrangeBeforePersist={arrangeBeforePersist}
            adaptDataForUpdate={adaptDataForUpdate}
            initialValues={initialValues}
            validationSchema={validationSchema}
            closeModal={() => setShowModal(false)}
            refreshList={() => setRefreshList(!refreshList)}
          >
            <Field
              name="tarih"
              label={t("newAnnouncements.bitisTarihi")}
              colNumber="6"
              component={ReactDatePicker}
              minDate={new Date()}
            />
            <Field
              name="baslik"
              label={t("newAnnouncements.baslik")}
              colNumber="12"
              component={TextInput}
            />
            <Field
              name="icerik"
              label={t("newAnnouncements.icerik")}
              colNumber="12"
              component={TextArea}
            />
            <Field
              name="aktif"
              label={t("demandList.durum")}
              colNumber="12"
              value={selectedRow?.aktif ? true : false} 
              component={Checkbox}
            />
          </FormikForm>
        </CrudMain>
      </div>
    </div>
      <div className="row">
      <div className="col-md-12">
        <ListComponent
          entityName="duyuru-listesi"
          endpoint="duyurular/list"
          keyField="id"
          hideSelection={true}
          refreshList={refreshList}
          customBody={{
            filters: filters,
          }}
          columns={[
            {
              dataField: "id",
              text: "Duyuru No",
              sort: true,
              headerClasses: "id-header"
            },
            {
              dataField: "baslik",
              text: `${t("newAnnouncements.baslik")}`,
              sort: true,
            },
            {
              dataField: "icerik",
              text: `${t("newAnnouncements.icerik")}`,
              sort: true,
            },
            {
              dataField: "tarih",
              text: `${t("newAnnouncements.bitisTarihi")}`,
              formatter: formatShortDate,
              sort: true,
            },
            {
              dataField: "aktif",
              text: `${t("demandList.durum")}`,
              formatter: formatTrueFalse,
              sort: true,
            },
            {
              dataField: "",
              text: "İşlemler",
              formatter: linkFollow,
            }
          ]}
        />
      </div>
    </div>
    <ConfirmModal 
      show={showConfirmModal} 
      selectedRow={selectedRow}
      setShowModal={setShowConfirmModal} 
      onYesButtonClicked={deleteAnnouncement}
      closeModal={() => setShowConfirmModal(false)}
      modalBodyMessage={t("modal.areYouSure")}
      modalTitle={t("modal.warningTitle")}
    />
    </Main>
  );
}